module.exports = __webpack_public_path__ + "static/media/pin-maps-active.40f169fe.svg";